export function posthogDebug(...args: unknown[]) {
  console.debug("🦔 posthog:", ...args)
}
